// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topics-carousel {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4rem;
    position: relative;
}

.topics {
    display: flex;
    gap: 1.1rem;
    overflow-x: auto;
    width: 50%;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;
    margin-top: 1rem;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.topics::-webkit-scrollbar {
    display: none;
}

.topic-card {
    padding: 1rem;
    background-color: #3c4f58;
    color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    flex: 0 0 23%;
    text-align: center;
    font-size: 1rem;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    scroll-snap-align: center;
    font-family: 'Rubik';
    height: 100px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

.topic-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.topic-card:active {
    transform: translateY(0);
}

.topic-card p {
    margin: 0;
    padding: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-height: 1.2;
    max-height: calc(1.2em * 3);
    pointer-events: none;
}

.carousel-button {
    background: transparent;
    border: none;
    font-size: 2.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #3c4f58;
}


.loading, .error, .no-data {
    text-align: center;
    padding: 2rem;
    color: #3c4f58;
    font-family: 'Rubik';
}

/* Popup Styles */
.popup {
    position: fixed;
    z-index: 1000;
    background-color: #fff;
    padding: 12px 16px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-width: 300px;
    color: #333;
    font-size: 0.9rem;
    line-height: 1.4;
    text-align: left;
    animation: fadeInUp 0.2s ease-out;
    pointer-events: none;
}

.popup::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #fff;
}

.popup-content {
    margin: 0;
    font-family: 'Rubik';
    font-size: 0.9rem;
    justify-content: center;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Slider/Slider.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,uBAAuB;IACvB,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,qDAAqD;IACrD,yBAAyB;IACzB,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,oBAAoB;AACxB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;AACtB","sourcesContent":[".topics-carousel {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 4rem;\r\n    position: relative;\r\n}\r\n\r\n.topics {\r\n    display: flex;\r\n    gap: 1.1rem;\r\n    overflow-x: auto;\r\n    width: 50%;\r\n    scroll-behavior: smooth;\r\n    scroll-snap-type: x mandatory;\r\n    margin-top: 1rem;\r\n    scrollbar-width: none;\r\n    -ms-overflow-style: none;\r\n}\r\n\r\n.topics::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\n.topic-card {\r\n    padding: 1rem;\r\n    background-color: #3c4f58;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    flex: 0 0 23%;\r\n    text-align: center;\r\n    font-size: 1rem;\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n    scroll-snap-align: center;\r\n    font-family: 'Rubik';\r\n    height: 100px;\r\n    overflow: hidden;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    user-select: none;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n}\r\n\r\n.topic-card:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.2);\r\n}\r\n\r\n.topic-card:active {\r\n    transform: translateY(0);\r\n}\r\n\r\n.topic-card p {\r\n    margin: 0;\r\n    padding: 0;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 3;\r\n    -webkit-box-orient: vertical;\r\n    line-height: 1.2;\r\n    max-height: calc(1.2em * 3);\r\n    pointer-events: none;\r\n}\r\n\r\n.carousel-button {\r\n    background: transparent;\r\n    border: none;\r\n    font-size: 2.5rem;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    padding: 1rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #3c4f58;\r\n}\r\n\r\n\r\n.loading, .error, .no-data {\r\n    text-align: center;\r\n    padding: 2rem;\r\n    color: #3c4f58;\r\n    font-family: 'Rubik';\r\n}\r\n\r\n/* Popup Styles */\r\n.popup {\r\n    position: fixed;\r\n    z-index: 1000;\r\n    background-color: #fff;\r\n    padding: 12px 16px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    max-width: 300px;\r\n    color: #333;\r\n    font-size: 0.9rem;\r\n    line-height: 1.4;\r\n    text-align: left;\r\n    animation: fadeInUp 0.2s ease-out;\r\n    pointer-events: none;\r\n}\r\n\r\n.popup::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -6px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 6px solid transparent;\r\n    border-right: 6px solid transparent;\r\n    border-top: 6px solid #fff;\r\n}\r\n\r\n.popup-content {\r\n    margin: 0;\r\n    font-family: 'Rubik';\r\n    font-size: 0.9rem;\r\n    justify-content: center;\r\n    text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
